import "bootstrap/dist/css/bootstrap.min.css";
import * as OFMSUI from "react-bootstrap";
import React, { useState } from "react";
import { MdOutlinePictureAsPdf } from "react-icons/md";
import NavigationServicesHeader from "../../../Header/NavigationServicesHeader";
import HousingService from "../../../Services/HousingService";
import { Table } from "react-bootstrap";
import moment from "moment-timezone";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { DashboardServiceReport, FormHeader, generatePDF, ModuleHeader } from "../../utils/commonFunctions";




const EmployeesData = () => {

    const [empData, setEmpData] = useState([]);
    const [countData, setCountData] = useState([]);
    const [empDesignData, seteDesignData] = useState([]);
    const [empRetiredData, setRetiredData] = useState([]);


    React.useEffect(() => {
        HousingService.getRetiredEmployees().then((res) => {
            if (res && res.data && res.data?.length > 0) {
                setRetiredData(res.data);
            }
        })
        HousingService.getEmployeesData().then((res) => {
            if (res && res.data && res.data?.length > 0) {
                setEmpData(res.data);
            }
        })
        HousingService.getDesignationWiseEmployeesData().then((res) => {
            if (res && res.data && res.data?.length > 0) {
                seteDesignData(res.data);
            }
        })


        HousingService.getDistWiseEmployeesData().then((res) => {
            if (res && res.data && res.data?.length > 0) {
                setCountData(res.data);
            }
        })
    }, []);







    return (
        <>
            <NavigationServicesHeader />
            <ModuleHeader title="Employee's Data Overview" />
            <OFMSUI.Container className="outer-page-content-container" fluid style={{ width: "90%" }}>
                <DashboardServiceReport title="Report" />
                <FormHeader title="Employee Details" />
                <OFMSUI.Row>
                    <OFMSUI.Col xs={12} sm={12} md={9} lg={12} xl={12} xxl={12} className=' mb-2 float-end' > <button type='button' className='btn btn-success btn-sm' style={{ float: 'right', color: '#fff', marginLeft: '3px' }} > <ReactHTMLTableToExcel id='my-table-xls-button' className='download-table-xls-button' table='my-table' filename='CBPayments' sheet='tablexls' buttonText='Excel' /> </button>
                        <button className='btn btn-danger btn-sm' onClick={() => generatePDF("my-table", "Employee's Overview", "EmployeesOverview.pdf", 9)} type='button' style={{ float: 'right', marginLeft: '3px' }} > PDF <MdOutlinePictureAsPdf /> </button> </OFMSUI.Col>
                </OFMSUI.Row>
                <OFMSUI.Row>
                    <OFMSUI.Col>
                        <div style={{ overflow: "auto", height: "500px" }}>
                            <Table striped bordered hover id='my-table' fluid>
                                <thead className='fw-bold' style={{ position: 'sticky', top: '0px' }} >
                                    <tr className='table_countshead'>
                                        <th>S.No.</th>
                                        <th>Employee Id</th>
                                        <th>Employee Name</th>
                                        <th>Designation</th>
                                        <th>Emplployee Type</th>
                                        <th>District</th>
                                        <th>Gender</th>
                                        <th>Date</th>
                                        <th>Working Status</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {empData && empData.length > 0 ? (empData.map((item, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{item.emp_id}</td>
                                            <td>{item.emp_name}</td>
                                            <td>{item.designation_name}</td>
                                            <td>{item.employee_type}</td>
                                            <td>{item.district}</td>
                                            <td>{item.gender}</td>
                                            <td>{moment(item.date).format("DD-MM-YYYY")}</td>
                                            <td>{item.working_status}</td>
                                        </tr>)))
                                        : (<tr> <td colSpan={12} style={{ textAlign: "center" }}>No data found</td> </tr>)} </tbody>
                                <tfoot> <tr class="table_countshead" style={{ position: 'sticky', bottom: '0px' }}>
                                    <td colSpan={9} style={{ textAlign: "end" }}> </td>
                                </tr> </tfoot>
                            </Table> </div>
                    </OFMSUI.Col>
                </OFMSUI.Row>
                <FormHeader title="Designation & District Wise Count (Working)" />
                <OFMSUI.Row>
                    <OFMSUI.Col xs={12} sm={12} md={9} lg={12} xl={12} xxl={12} className=' mb-2 float-end' > <button type='button' className='btn btn-success btn-sm' style={{ float: 'right', color: '#fff', marginLeft: '3px' }} > <ReactHTMLTableToExcel id='my-table-xls-button' className='download-table-xls-button' table='my-table1' filename='CBPayments' sheet='tablexls' buttonText='Excel' /> </button>
                        <button className='btn btn-danger btn-sm' onClick={() => generatePDF("my-table1", "District Wise Employees Count", "EmployeesOverview.pdf", 9)} type='button' style={{ float: 'right', marginLeft: '3px' }} > PDF <MdOutlinePictureAsPdf /> </button>
                    </OFMSUI.Col>
                </OFMSUI.Row>

                <OFMSUI.Row>

                    <OFMSUI.Col>
                        <div style={{ overflow: "auto", height: "500px" }}>
                            <Table striped bordered hover id='my-table1' fluid>
                                <thead className='fw-bold' style={{ position: 'sticky', top: '0px' }} >
                                    <tr className='table_countshead'>
                                        <th>S.No.</th>
                                        <th>Designation</th>
                                        <th>Total</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {empDesignData && empDesignData.length > 0 ? (empDesignData.map((item, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{item.designation_name}</td>
                                            <td>{item.count}</td>
                                        </tr>)))
                                        : (<tr> <td colSpan={8} style={{ textAlign: "center" }}>No data found</td> </tr>)} </tbody>
                                <tfoot> <tr class="table_countshead" style={{ position: 'sticky', bottom: '0px' }}>
                                    <td colSpan={2} style={{ textAlign: "end" }}> Total </td>
                                    <td> {empDesignData?.reduce((a, v) => a + v.count, 0)} </td>
                                </tr> </tfoot>
                            </Table> </div>
                    </OFMSUI.Col>

                    <OFMSUI.Col>
                        <div style={{ overflow: "auto", height: "500px" }}>
                            <Table striped bordered hover id='my-table1' fluid>
                                <thead className='fw-bold' style={{ position: 'sticky', top: '0px' }} >
                                    <tr className='table_countshead'>
                                        <th>S.No.</th>
                                        <th>District</th>
                                        <th>Regular</th>
                                        <th>Deputation</th>
                                        <th>Consultant</th>
                                        <th>NMR</th>
                                        <th>Special Officers</th>
                                        <th>Total employees</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {countData && countData.length > 0 ? (countData.map((item, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{item.district}</td>
                                            <td>{item.regular}</td>
                                            <td>{item.deputation}</td>
                                            <td>{item.consultant}</td>
                                            <td>{item.nmr}</td>
                                            <td>{item.special_officers}</td>
                                            <td>{item.total_employees}</td>
                                        </tr>)))
                                        : (<tr> <td colSpan={8} style={{ textAlign: "center" }}>No data found</td> </tr>)} </tbody>
                                <tfoot> <tr class="table_countshead" style={{ position: 'sticky', bottom: '0px' }}>
                                    <td colSpan={2} style={{ textAlign: "end" }}> Total </td>
                                    <td> {countData?.reduce((a, v) => a + v.regular, 0)} </td>
                                    <td> {countData?.reduce((a, v) => a + v.deputation, 0)} </td>
                                    <td> {countData?.reduce((a, v) => a + v.consultant, 0)} </td>
                                    <td> {countData?.reduce((a, v) => a + v.nmr, 0)} </td>
                                    <td> {countData?.reduce((a, v) => a + v.special_officers, 0)} </td>
                                    <td> {countData?.reduce((a, v) => a + v.total_employees, 0)} </td>
                                </tr> </tfoot>
                            </Table> </div>
                    </OFMSUI.Col>

                </OFMSUI.Row>
                <FormHeader title="Retired Employee Details" />
                <OFMSUI.Row>
                    <OFMSUI.Col xs={12} sm={12} md={9} lg={12} xl={12} xxl={12} className=' mb-2 float-end' > <button type='button' className='btn btn-success btn-sm' style={{ float: 'right', color: '#fff', marginLeft: '3px' }} > <ReactHTMLTableToExcel id='my-table-xls-button' className='download-table-xls-button' table='my-table' filename='CBPayments' sheet='tablexls' buttonText='Excel' /> </button>
                        <button className='btn btn-danger btn-sm' onClick={() => generatePDF("my-table", "Employee's Overview", "EmployeesOverview.pdf", 9)} type='button' style={{ float: 'right', marginLeft: '3px' }} > PDF <MdOutlinePictureAsPdf /> </button> </OFMSUI.Col>
                </OFMSUI.Row>
                <OFMSUI.Row>
                    <OFMSUI.Col>
                        <div style={{ overflow: "auto", height: "500px" }}>
                            <Table striped bordered hover id='my-table' fluid>
                                <thead className='fw-bold' style={{ position: 'sticky', top: '0px' }} >
                                    <tr className='table_countshead'>
                                        <th>S.No.</th>
                                        <th>Employee Id</th>
                                        <th>Employee Name</th>
                                        <th>Designation</th>
                                        <th>Emplployee Type</th>
                                        <th>District</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {empRetiredData && empRetiredData.length > 0 ? (empRetiredData.map((item, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{item.emp_id}</td>
                                            <td>{item.emp_name}</td>
                                            <td>{item.designation_name}</td>
                                            <td>{item.employee_type}</td>
                                            <td>{item.security_name}</td>
                                        </tr>)))
                                        : (<tr> <td colSpan={6} style={{ textAlign: "center" }}>No data found</td> </tr>)} </tbody>
                                <tfoot> <tr class="table_countshead" style={{ position: 'sticky', bottom: '0px' }}>
                                    <td colSpan={9} style={{ textAlign: "end" }}> </td>
                                </tr> </tfoot>
                            </Table> </div>
                    </OFMSUI.Col>
                </OFMSUI.Row>
            </OFMSUI.Container>

        </>

    );
};

export default EmployeesData;
